import React from "react";
import { useParams } from "react-router-dom";
import useSurvey from "hooks/surveys/useSurvey";
import SurveyView from "components/surveys/SurveyView";
import Loading from "components/common/Loading";

const Survey = ({ isEditable }) => {
  const { id } = useParams();
  const { current, isLoading } = useSurvey({ id });
  return (
    <div>
      {isLoading ? (
        <Loading />
      ) : (
        <SurveyView survey={current} isEditable={isEditable} />
      )}
    </div>
  );
};

export default Survey;
